<template>
	<label class="wa-switch">
		<input class="wa-switch-input" :disabled="disabled" @change="$emit('change', !currentValue)" type="checkbox" v-model="currentValue">
		<span class="wa-switch-core"></span>
		<div class="wa-switch-label"><slot></slot></div>
	</label>
</template>
<script>
/**
 * switch
 * @desc 切换按钮
 * @param {boolean} [value] - 绑定值，支持双向绑定
 * @param {slot} - 显示内容
 *
 * @example
 * <switch v-model="value"></switch>
 */
export default {
	name: 'wa-switch',
	props: {
		value: Boolean,
		disabled: {
			type: Boolean,
			default: false
		}
	},
	// 实时计算
	computed: {
		currentValue: {
			get () {
				return this.value
			},
			set (val) {
				this.$emit('input', val)
			}
		}
	}
}
</script>

<style lang="css">
.wa-switch {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	position: relative;
}
.wa-switch * {
	pointer-events: none;
}
.wa-switch-label {
	margin-left: 10px;
	display: inline-block;
}
.wa-switch-label:empty {
	margin-left: 0;
}
.wa-switch-core {
	display: inline-block;
	position: relative;
	width: 52px;
	height: 32px;
	border: 1px solid #d9d9d9;
	border-radius: 16px;
	box-sizing: border-box;
	background: #d9d9d9;
}
.wa-switch-core::after, .wa-switch-core::before {
	content: " ";
	top: 0;
	left: 0;
	position: absolute;
	-webkit-transition: -webkit-transform .3s;
	transition: -webkit-transform .3s;
	transition: transform .3s;
	transition: transform .3s, -webkit-transform .3s;
	border-radius: 15px;
}
.wa-switch-core::after {
	width: 30px;
	height: 30px;
	background-color: #fff;
	box-shadow: 0 1px 3px rgba(0, 0, 0, .4);
}
.wa-switch-core::before {
	width: 50px;
	height: 30px;
	background-color: #fdfdfd;
}
.wa-switch-input {
	display: none;
}
.wa-switch-input:checked + .wa-switch-core {
	border-color: #26a2ff;
	background-color: #26a2ff;
}
.wa-switch-input:checked + .wa-switch-core::before {
	-webkit-transform: scale(0);
			transform: scale(0);
}
.wa-switch-input:checked + .wa-switch-core::after {
	-webkit-transform: translateX(20px);
			transform: translateX(20px);
}

</style>



// WEBPACK FOOTER //
// Switch.vue?1b756093